import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Grid, makeStyles, Divider, FormControlLabel, Switch } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Door24Icon from 'assets/images/door-24.svg';
import { LeaveTeamModal } from 'components/Modals/LeaveTeamModal';
import { RootStore } from 'redux/store';
import './OptionsAccordion.scss';
import { AddTeamMembersModal } from 'components/Modals/AddTeamMembersModal';
import { toggleAllNotification, togglePersonalNotification } from 'redux/thunks';

const useStyles = makeStyles({
	root: {
		backgroundColor: 'background-color: rgba(0, 0, 0, 0) !important',
		'&::before': {
			backgroundColor: 'transparent',
		},
	},
	switchText: {
		fontSize: '14px',
	},
});

const OptionsAccordion: React.FC = () => {
	const [leaveTeamModalOpen, setLeaveTeamModalOpen] = useState(false);
	const [addTeamMembersModalOpen, setAddTeamMembersModalOpen] = useState(false);
	const [allNotifications, setAllNotifications] = useState(false);
	const [personalNotifications, setPersonalNotifications] = useState(false);
	const selectedTeam = useSelector((state: RootStore) => state.user.selectedTeam);
	const userId = useSelector((state: RootStore) => state.user.userId);
	const classes = useStyles();
	const dispatch = useDispatch();

	const onViewLeaveTeamModalClicked = () => {
		setLeaveTeamModalOpen(true);
	};

	const onViewLeaveTeamModalClosed = () => {
		setLeaveTeamModalOpen(false);
	};

	const onViewAddTeamMembersModalClicked = () => {
		setAddTeamMembersModalOpen(true);
	};

	const onViewAddTeamMembersModalClosed = () => {
		setAddTeamMembersModalOpen(false);
	};

	const handleAllNotificationsClick = () => {
		if (selectedTeam?.teamId) {
			dispatch(toggleAllNotification(selectedTeam?.teamId));
		}
	};

	const handlePersonalNotificationsClick = () => {
		if (selectedTeam?.teamId) {
			dispatch(togglePersonalNotification(selectedTeam?.teamId));
		}
	};

	useEffect(() => {
		if (selectedTeam && selectedTeam?.allNotifications !== allNotifications) {
			setAllNotifications(selectedTeam?.allNotifications);
		}

		if (selectedTeam && selectedTeam?.personalNotifications !== personalNotifications) {
			setPersonalNotifications(selectedTeam?.personalNotifications);
		}
	}, [selectedTeam, personalNotifications, allNotifications, setAllNotifications, setPersonalNotifications]);

	return (
		<>
			<Accordion className='team-options-accordion' classes={{ root: classes.root }} defaultExpanded={true}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls='options-panel-content'
					id='options-panel-header'
					className='options-accordion-summary'
				>
					<Typography className='options-accordion-header'>options</Typography>
				</AccordionSummary>
				<AccordionDetails className='options-accordion-details'>
					<Grid container direction='column' className='options-accordion-grid'>
						<Grid item container alignItems='center' className='accordion-item-grid' onClick={onViewAddTeamMembersModalClicked}>
							<Grid item>
								<PersonAddIcon className='invite-members-icon' />
							</Grid>
							<Grid item>Add Members</Grid>
						</Grid>
						<Grid container alignItems='center' className='accordion-item-grid leave-team-grid-item' onClick={onViewLeaveTeamModalClicked}>
							<Grid item>
								<img src={Door24Icon} className='door-icon' alt='door' />
							</Grid>
							<Grid item>Leave Team</Grid>
						</Grid>
					</Grid>
					<Divider className='options-accordion-divider' />
					<Grid container direction='column' className='options-accordion-grid'>
						<Typography className='options-accordion-header'>Notifications</Typography>

						<Grid item container alignItems='center' className='accordion-item-grid'>
							<Grid item>
								<FormControlLabel
									className='options__switch-text'
									classes={{ label: classes.switchText }}
									control={<Switch name='checkedB' color='primary' />}
									label='When I receive tokens'
									onChange={handlePersonalNotificationsClick}
									checked={personalNotifications}
								/>
							</Grid>
							<Grid item>
								<FormControlLabel
									className='options__switch-text'
									classes={{ label: classes.switchText }}
									control={<Switch name='checkedB' color='primary' />}
									label='When anyone receives tokens'
									onChange={handleAllNotificationsClick}
									checked={allNotifications}
								/>
							</Grid>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			<LeaveTeamModal
				open={leaveTeamModalOpen}
				teamName={selectedTeam?.teamName || ''}
				teamId={selectedTeam?.teamId || ''}
				onCloseClicked={onViewLeaveTeamModalClosed}
				allowClickOutsideToClose={true}
			/>
			<AddTeamMembersModal
				open={addTeamMembersModalOpen}
				userId={userId}
				teamName={selectedTeam?.teamName || ''}
				teamId={selectedTeam?.teamId || ''}
				onCloseClicked={onViewAddTeamMembersModalClosed}
				allowClickOutsideToClose={true}
			/>
		</>
	);
};

export default OptionsAccordion;
